import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { initializePaddle, Paddle } from '@paddle/paddle-js'
import config from 'lib/config'
import { State } from 'redux/types'

interface PaddleInitProps {
    isAuthenticated?: boolean
    paddleCustomerId?: string | null
}

declare global {
    interface Window {
        Paddle?: Paddle
    }
}

const PaddleInit = ({ isAuthenticated = false, paddleCustomerId = null }: PaddleInitProps) => {
    const user = useSelector((state: State) => state.user)

    useEffect(() => {
        const initializePaddleJS = async () => {
            try {
                const paddleToken = config.getPaddleToken()

                // Basic configuration for all pages
                const paddleConfig = {
                    token: paddleToken,
                    pwCustomer: undefined as { id: string } | undefined,
                }

                if (isAuthenticated && user && paddleCustomerId) {
                    paddleConfig.pwCustomer = {
                        id: paddleCustomerId, // Must be Paddle customer ID (ctm_xxx)
                    }
                }

                const paddle: Paddle | undefined = await initializePaddle({
                    token: paddleConfig.token,
                    ...(paddleConfig.pwCustomer && { pwCustomer: paddleConfig.pwCustomer }),
                })

                if (paddle) {
                    window.Paddle = paddle

                    console.log('Paddle.js initialized successfully')
                } else {
                    console.error('Failed to initialize Paddle.js')
                }
            } catch (error) {
                console.error('Failed to initialize Paddle.js:', error)
            }
        }

        initializePaddleJS()
    }, [isAuthenticated, user, paddleCustomerId])

    return null
}

export default PaddleInit
